import styled from 'styled-components';

import { Theme } from 'baukasten';

/**
 * Local instead of baukasten's icon-only `Button`: that one fixes its icons at 24px and
 * only takes `primary`/`danger`, while the chat needs 20px icons in `grey-dark`.
 */
export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${Theme.getColor('grey-light-50')};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
